<template>
  <div class="technical-documentation-tab">
    <div class="text-h6 q-mb-md">Technical Specifications</div>

    <div class="row q-col-gutter-md">
      <div class="col-12 col-md-6">
        <q-input
          :model-value="modelValue.technical_specs?.manufacturer"
          label="Manufacturer"
          outlined
          dense
          class="q-mb-sm"
          @update:model-value="updateField('manufacturer', $event)"
        />

        <q-input
          :model-value="modelValue.technical_specs?.model"
          label="Model Number"
          outlined
          dense
          class="q-mb-sm"
          @update:model-value="updateField('model', $event)"
        />

        <q-input
          :model-value="modelValue.technical_specs?.serial_number"
          label="Serial Number"
          outlined
          dense
          class="q-mb-sm"
          @update:model-value="updateField('serial_number', $event)"
        />

        <q-input
          :model-value="modelValue.technical_specs?.capacity"
          label="Capacity / Size"
          outlined
          dense
          class="q-mb-sm"
          @update:model-value="updateField('capacity', $event)"
        />

        <PointUnitSelector
          :model-value="modelValue.technical_specs?.capacity_unit_id"
          label="Capacity Unit"
          outlined
          dense
          class="q-mb-sm"
          @update:model-value="updateField('capacity_unit_id', $event)"
        />
      </div>

      <div class="col-12 col-md-6">
        <q-input
          :model-value="modelValue.technical_specs?.power_rating"
          label="Power Rating (kW)"
          outlined
          dense
          class="q-mb-sm"
          @update:model-value="updateField('power_rating', $event)"
        />

        <q-input
          :model-value="modelValue.technical_specs?.efficiency"
          label="Efficiency Rating"
          outlined
          dense
          class="q-mb-sm"
          @update:model-value="updateField('efficiency', $event)"
        />

        <q-input
          :model-value="modelValue.technical_specs?.install_date"
          label="Installation Date"
          type="date"
          outlined
          dense
          class="q-mb-sm"
          @update:model-value="updateField('install_date', $event)"
        />

        <q-input
          :model-value="modelValue.technical_specs?.warranty_expiry"
          label="Warranty Expiry Date"
          type="date"
          outlined
          dense
          @update:model-value="updateField('warranty_expiry', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
  import PointUnitSelector from '../PointUnitSelector.vue';

  /**
   * Technical Documentation Tab Component
   *
   * Displays form for documenting technical specifications
   */

  const props = defineProps({
    modelValue: {
      type: Object,
      required: true,
      default: () => ({
        technical_specs: {
          manufacturer: '',
          model: '',
          serial_number: '',
          capacity: '',
          capacity_unit_id: null,
          power_rating: '',
          efficiency: '',
          install_date: '',
          warranty_expiry: '',
        },
      }),
    },
  });

  const emit = defineEmits(['update:technical-spec']);

  function updateField(field, value) {
    emit('update:technical-spec', { field, value });
  }
</script>

<style scoped>
.technical-documentation-tab {
  height: 100%;
}
</style>
